"use client";
import { api } from "@/lib/api/api";
import { useQuery } from "@tanstack/react-query";

export const useWorkplaceRequestByIdKey = "workplaceRequestById";
export function useWorkplaceRequestById(requestId: string) {
  return useQuery({
    queryKey: [useWorkplaceRequestByIdKey, requestId],
    queryFn: async () => {
      const result =
        await api.client.workplaceRequests.getWorkplaceRequestById(requestId);
      return result.result;
    },
    enabled: !!requestId
  });
}
